import React, { memo, useEffect, useRef, useState } from "react";
import { Offcanvas, OverlayTrigger, Popover } from "react-bootstrap";
import { parse } from "query-string";
import Select from "react-select";
import "../../../include/css/dev.css";
import "../../../include/css/brand.css";
import {
  getAuctionListingPictures,
  getProductDetailListingRefresh,
  getProductDetailRefresh,
  updatePostListing,
  updatePostListingBasics,
  updatePostListingPricing,
} from "../../../actions/dashboardAction";
import { decode, imageUrl } from "../../../actions/miscAction";
import {
  fileDelete,
  getCountries,
  getStates,
  imageDelete,
  imageUpload,
  markAsPrimary,
  privateFileUpload,
  updatePictureCaption,
} from "../../../actions/memberAction";
import Editor from "../../common/editor/editor";
import { Scrib } from "../../common/editImage/scribble";
import Edit from "../../common/editImage/editImageNew";
import DeleteModal from "../../common/deleteModal";
import LoadingBar from "react-top-loading-bar";
import AlertError from "../../common/alertError";
import { toast } from "react-toastify";
import AlertSuccess from "../../common/alertSuccess";
import _ from "lodash";
import Amplify, { Auth, Storage } from "aws-amplify";
import { v4 as uuidv4 } from "uuid";
import { dataURLtoFile } from "../../common/editImage/dataURLtoFile";

const closeIcon = imageUrl("close-icon.svg");
const uploadImg = imageUrl("upload-img.jpg");
const pdfIcon = imageUrl("pdf-doc-img.svg");
const featured = imageUrl("uib-icon-1.svg");
const yellowFeatured = imageUrl("yellow-star-icon.svg");
const tag = imageUrl("uib-icon-2.svg");
const crop = imageUrl("uib-icon-3.svg");
const rotate = imageUrl("uib-icon-4.svg");
const scribble = imageUrl("uib-icon-5.svg");
const deleteIcon = imageUrl("uib-icon-6.svg");
const save = imageUrl("save.svg");
const cropNew = imageUrl("crop-new.svg");

const conditionOptions = [
  { name: "New", value: "New" },
  { name: "New Surplus", value: "New Surplus" },
  { name: "Used", value: "Used" },
  { name: "Damaged", value: "Damaged" },
  { name: "Scrap", value: "Scrap" },

  { name: "Factory New", value: "Factory New" },
  { name: "Overhauled", value: "Overhauled" },
  { name: "Serviceable", value: "Serviceable" },
  { name: "As Removed", value: "As Removed" },
  { name: "Repairable", value: "Repairable" },
  { name: "Repaired", value: "Repaired" },
  { name: "Inspected", value: "Inspected" },
  { name: "Core", value: "Core" },

  { name: "Beyond Economical Repair", value: "Beyond Economical Repair" },
  { name: "Rebuilt", value: "Rebuilt" },
  { name: "Modified", value: "Modified" },

  { name: "Tested", value: "Tested" },
  { name: "Unserviceable", value: "Unserviceable" },

  { name: "Disposal", value: "Disposal" },
  { name: "Disposal/Free", value: "Disposal/Free" },
  { name: "Unused", value: "Unused" },

  { name: "Others", value: "Others" },
];

const customStyles = {
  indicatorSeparator: (styles) => ({ display: "none" }),
  option: (provided, state) => ({
    ...provided,
    "&:hover": {
      backgroundColor: "#47ad1d",
      color: "#fff",
    },
    display: "-webkit-box",
    WebkitLineClamp: 3,
    WebkitBoxOrient: "vertical",
    overflow: "hidden",
    color: state.isSelected ? "#fff" : "black",
    backgroundColor: state.isSelected ? "#47ad1d" : provided.backgroundColor,
    maxHeight: "84px",
    //backgroundColor: state.isSelected ? "rgb(95, 50, 187, 10%)" : "white",
  }),
  control: (base, state) => ({
    ...base,
    height: 42,
    minHeight: 42,
    borderColor: state.isFocused ? "#47AD1D" : "#e4e4e4",
    boxShadow: state.isFocused ? "0 0 0 0.5px #47AD1D" : "0",
    border: state.isHovered ? "0" : "1px solid #e4e4e4",

    "&:hover": {
      borderColor: state.isFocused ? "#47AD1D" : "0",
      boxShadow: state.isFocused ? "0 0 0 0.5px #47AD1D" : "0",
    },
    // "&:focus": {
    //   borderColor: "#47AD1D",
    //   boxShadow: "0 0 0 0.5px #47AD1D"

    // },
  }),
  multiValueRemove: (base, state) => ({
    ...base,
    "&:hover": {
      backgroundColor: "rgb(95, 50, 187, 10%)",
      color: "#6119c0",
    },
  }),
};

const EditListing = ({ ...props }) => {
  const ref = useRef(null);
  const scribbleRef = useRef(null);
  const childRef = useRef(null);
  const inputRef = useRef(null);

  const [tab, setTab] = useState(props?.tab ? props?.tab : "information");
  // const [detail, setDetail] = useState({});
  const [loadingDetail, setLoadingDetail] = useState(true);
  const [allCountries, setAllCountries] = useState([]);
  const [allStates, setAllStates] = useState([]);
  const [otherCondition, setOtherCondition] = useState("");
  const [descpSavedData, setDescpSavedData] = useState("");
  const [conditionDescpData, setConditionDescpData] = useState("");
  const [errors, setErrors] = useState({});
  const [deleteModal, setDeleteModal] = useState(false);
  const [loadingUpdate, setLoadingUpdate] = useState(false);
  const [selectedMedia, setSelectedMedia] = useState(null);
  const [detail, setDetail] = useState(null);

  //Photos
  const [loadingMedia, setLoadingMedia] = useState(false);
  const [selectedUploadMedia, setSelectedUploadMedia] = useState([]);
  const [progress, setProgress] = useState("");
  const [fileType, setFileType] = useState(".pdf");
  const [docTitle, setDocTitle] = useState("");
  const [optionType, setOptionType] = useState("");
  const [optionTypeId, setOptionTypeId] = useState("");
  const [title, setTitle] = useState("");
  const [selectedImage, setSelectedImage] = useState(null);
  const [editedFile, setEditedFile] = useState(null);

  useEffect(() => {
    if (props?.show) {
      setTab(props.tab ? props.tab : "information");
      setOptionType(props?.type ? props?.type : "");
      setSelectedImage(props?.image ? props?.image : null);
    }
  }, [props?.show]);

  useEffect(() => {
    if (props?.show && props?.selectedListing?.id) {
      const id = props?.selectedListing?.id;

      if (typeof window !== "undefined" && localStorage.getItem("member")) {
        if (props?.selectedListing?.id) {
          setLoadingDetail(true);
          ref?.current?.continuousStart();

          getCountries((res) => {
            if (res && res.status == 200) {
              setAllCountries(res.data);
            }
          });

          getStates((res) => {
            if (res && res.status == 200) {
              setAllStates(res.data);
            }
          });

          getProductDetailListingRefresh(id, (res) => {
            if (res?.status === 200) {
              const allData = res.data;
              const updateData = allData.detail;
              const data = {};
              data.auction_id = updateData.auction_id || "";
              data.title = updateData.title || "";
              data.condition = updateData.condition || "";
              data.special_instr = updateData.special_instr || "";
              data.description = updateData.details || "";
              data.quantity = updateData.quantity || "";
              data.unit = updateData.unit || "";
              // data.deadline = updateData.due_date || ""

              data.c_name = updateData.c_name || "";
              data.company = updateData.c_company || "";
              data.c_phone = updateData.c_phone || "";
              data.c_fax = updateData.c_fax || "";
              data.c_email = updateData.c_email || "";
              data.address_1 = updateData.address_1 || "";
              data.city = updateData.city || "";
              data.zip = updateData.zip || "";
              data.state = updateData.state_id ? { name: updateData.state, value: updateData.state_id } : {};
              data.country = updateData.country_id ? { name: updateData.ccountry, value: updateData.country_id } : {};
              data.asking_price = allData.reserverPrice || 0;
              data.reserve_price = allData.reserverPrice || 0;
              data.retail_value = allData.retailValue || 0;
              data.wholesale_value = allData.wholesaleValueAdmin || 0;
              data.claim_value = allData.claimValue || 0;
              data.geo_long = updateData.geo_long || 0;
              data.geo_lat = updateData.geo_lat || 0;
              data.images = allData.pics;
              data.documents = allData.privateDocuments;
              if (updateData?.conditionType) {
                const a = conditionOptions?.filter((item) => item?.name == updateData?.conditionType);

                if (a?.length > 0) {
                  data.conditionType = {
                    name: updateData?.conditionType,
                    value: updateData?.conditionType,
                  };
                } else {
                  data.conditionType = { name: "Others", value: "Others" };
                  setOtherCondition(updateData?.conditionType);
                }
              } else {
                data.conditionType = {
                  name: "Select Condition",
                  value: "Select Condition",
                };
              }
              setDescpSavedData(updateData?.details || "");
              setConditionDescpData(updateData?.condition || "");
              setDetail(data);
            }
            setLoadingDetail(false);
            ref?.current?.complete();
          });
        }
      } else {
        window.location.href = "/members/login";
      }
    } else {
      setDetail(null);
    }
  }, [props?.selectedListing?.id]);

  const onchange = (event) => {
    const name = event.target.name;
    const value = event.target.value;
    const data = { ...detail };
    data[name] = value;
    setDetail(data);
  };

  const toggleDeleteModal = () => {
    setDeleteModal(!deleteModal);
  };

  const handleDeleteImg = () => {
    setLoadingMedia(true);
    ref?.current?.continuousStart();
    imageDelete(selectedMedia?.picture_id, (res) => {
      if (res.status === 200) {
        getProductDetailListingRefresh(props?.selectedListing?.id, (res2) => {
          setLoadingMedia(false);
          getAuctionListingPictures(props?.selectedListing?.id, (res3) => {
            if (res3.status === 200) {
              props?.setImages(res3.data);
            }
          });
          toggleDeleteModal();
          if (res2.status === 200) {
            const data = { ...detail };
            data.images = res2.data.pics;
            setDetail(data);
          }
          toast(<AlertSuccess message="Information Saved" />);
          ref?.current?.complete();
        });
      } else {
        toast(<AlertError message={res.response.data.message || "Something went wrong"} />);
      }
    });
  };
  const handlePrimayImg = (id) => {
    setLoadingMedia(true);
    ref?.current?.continuousStart();
    const payload = {
      picture_id: id,
    };
    markAsPrimary(props?.selectedListing?.id, payload, (res) => {
      if (res.status === 200) {
        getProductDetailListingRefresh(props?.selectedListing?.id, (res2) => {
          if (res2.status === 200) {
            const data = { ...detail };
            data.images = res2.data.pics;
            setDetail(data);
            getAuctionListingPictures(props?.selectedListing?.id, (res3) => {
              if (res3.status === 200) {
                props?.setImages(res3.data);
              }
            });
            setLoadingMedia(false);
            ref?.current?.complete();
          }
        });
      } else {
        toast(<AlertError message={res.response.data.message || "Something went wrong"} />);
      }
    });
  };

  const handleSaveTitle = () => {
    setLoadingMedia(true);
    ref?.current?.continuousStart();
    const payload = {
      picture_id: optionTypeId,
      caption: title,
    };
    updatePictureCaption(props?.selectedListing?.id, payload, (res) => {
      getProductDetailListingRefresh(props?.selectedListing?.id, (res2) => {
        setLoadingMedia(false);
        if (res2.status === 200) {
          const data = { ...detail };
          data.images = res2.data.pics;
          setDetail(data);
          getAuctionListingPictures(props?.selectedListing?.id, (res3) => {
            if (res3.status === 200) {
              props?.setImages(res3.data);
            }
          });
          setOptionType("");
          ref?.current?.complete();
        } else {
          toast(<AlertError message={res2.response.data.message || "Something went wrong"} />);
        }
      });
    });
  };
  const handleDeleteDoc = () => {
    setLoadingMedia(true);
    ref?.current?.continuousStart();
    fileDelete(selectedMedia?.doc_id, () => {
      getProductDetailListingRefresh(props?.selectedListing?.id, (res2) => {
        setLoadingMedia(false);
        toggleDeleteModal();
        if (res2.status === 200) {
          const data = { ...detail };
          data.documents = res2.data.privateDocuments;
          setDetail(data);
        } else {
          toast(<AlertError message={res2.response.data.message} />);
        }
        ref?.current?.complete();
      });
    });
  };

  const doSubmit = (e) => {
    if (e) e.preventDefault();
    ref?.current?.continuousStart();
    setLoadingUpdate(true);
    const data = { ...detail };
    const error = { ...errors };

    if (tab === "information") {
      if (!data.title) {
        error.title = "Title is required";
      }

      if (!data.description) {
        error.description = "Description is required";
      }

      if (!_.isEmpty(error)) {
        return ref?.current?.complete(), setLoadingUpdate(false), setErrors(error);
      }

      const payLoad = {
        auction_id: data.auction_id,
        title: data.title,
        condition: conditionDescpData,
        description: descpSavedData,
        special_instr: data.special_instr,
        conditionType: data.conditionType?.value != "Others" ? data?.conditionType?.value : otherCondition,
      };

      updatePostListingBasics(payLoad, callBack);
    } else if (tab === "location") {
      const payLoad = {
        auction_id: data.auction_id,
        c_name: data.c_name,
        c_phone: data.c_phone,
        c_fax: data.c_fax,
        c_email: data.c_email,
        address_1: data.address_1,
        city: data.city,
        zip: data.zip,
        state_id: data.state?.value ? parseInt(data.state?.value) : 0,
        country_id: data.country?.value ? parseInt(data.country?.value) : 0,
        c_company: data.company,
        geo_long: data.geo_long,
        geo_lat: data.geo_lat,
      };
      if (parseInt(data.country?.value) != "1001") {
        delete payLoad.state_id;
      }

      updatePostListing(payLoad, callBack);
    } else if (tab === "pricing") {
      const payLoad = {
        auction_id: parseFloat(data.auction_id),
        // asking_price: parseInt(data.asking_price),
        reserve_price: parseFloat(data.reserve_price),
        retail_value: parseFloat(data.retail_value),
        wholesale_value: parseFloat(data.wholesale_value),
        claim_value: parseFloat(data.claim_value),
        quantity: data.quantity,
        unit: data.unit,
      };

      updatePostListingPricing(payLoad, callBack);
    } else {
      props?.onHide();
    }
  };

  const callBack = (res) => {
    ref?.current?.complete();
    setLoadingUpdate(false);
    if (res.status === 200) {
      toast(<AlertSuccess message="Information Saved" />);
    } else {
      toast(<AlertError message={res.response && res.response.data && res.response.data.message} />);
    }
  };

  const validateTitle = () => {
    const error = { ...errors };
    if (docTitle && docTitle.trim().length > 0) {
      error.docTitle = "";
    }

    if (selectedUploadMedia && selectedUploadMedia?.length > 0) {
      error.document = "";
    }

    if (!selectedUploadMedia || selectedUploadMedia?.length == 0) {
      error.document = <p className="val-error-text">Document is required</p>;
    }

    if (!docTitle || !docTitle?.trim() || !docTitle?.trim()?.length) {
      error.docTitle = <p className="val-error-text">Title is required</p>;
    }
    const isEmpty = Object.values(error).every((x) => x === null || x === "");

    if (!isEmpty) {
      setErrors(error);
      return true;
    } else {
      setErrors(error);
      return false;
    }
  };

  const removeUploaded = (res) => {
    const a = selectedUploadMedia.filter((item) => item.name !== res.name);
    setSelectedUploadMedia(a);
  };

  const onSelectMedia = (e, type) => {
    const imageContainer = [];
    for (let i = 0; i < e.target.files.length; i++) {
      const fSize = Math.round(e.target.files[i].size / 1048576);
      const fType = e.target.files[i].type;
      if (fSize > 25) {
        toast(<AlertError message="File size exceeds maximum allowable size. Maximum allowable size is 25MB." />);
        return;
      } else if (
        type === "doc"
          ? ![
              "application/pdf",
              "text/csv",
              "application/vnd.ms-excel",
              "application/vnd.openxmlformats-officedocument.spreadsheetml.sheet",
              "application/msword",
              "application/vnd.openxmlformats-officedocument.wordprocessingml.document",
            ].includes(fType)
          : !["image/jpeg", "image/jpg", "image/png"].includes(fType)
      ) {
        toast(
          <AlertError
            message={
              type === "doc"
                ? "File is not of correct format and hence cannot be uploaded. Valid document formats are pdf, xlsx, xls, doc, docx and csv."
                : "File is not of correct format and hence cannot be uploaded. Valid image formats are  JPG, JPEG, PNG ."
            }
          />,
        );
        return;
      } else {
        imageContainer.push(e.target.files[i]);
      }
    }
    setSelectedUploadMedia([...imageContainer, ...selectedUploadMedia]);
  };

  const onUploadMedia = (type) => {
    setLoadingMedia(true);
    setProgress("uploading");
    ref?.current?.continuousStart();
    for (let i = 0; i < selectedUploadMedia?.length; i++) {
      const fSize = Math.round(selectedUploadMedia[i].size / 1048576);
      const fType = selectedUploadMedia[i].type;
      const ext = selectedUploadMedia[i].name.split(".").pop();
      if (fSize > 25) {
        toast(<AlertError message="File size exceeds maximum allowable size. Maximum allowable size is 25MB." />);
        return setLoadingMedia(false), setProgress("failed"), ref?.current?.complete();
      } else if (
        type === "doc"
          ? ![
              "application/pdf",
              "text/csv",
              "application/vnd.ms-excel",
              "application/vnd.openxmlformats-officedocument.spreadsheetml.sheet",
              "application/msword",
              "application/vnd.openxmlformats-officedocument.wordprocessingml.document",
            ].includes(fType)
          : !["image/jpeg", "image/jpg", , "image/png"].includes(fType)
      ) {
        toast(
          <AlertError
            message={
              type === "doc"
                ? "File is not of correct format and hence cannot be uploaded. Valid document formats are pdf, xlsx, xls, doc, docx and csv."
                : "File is not of correct format and hence cannot be uploaded. Valid image formats are  JPG, JPEG, PNG ."
            }
          />,
        );
        return setLoadingMedia(false), setProgress("failed"), ref?.current?.complete();
      } else {
        ref.current && ref.current.continuousStart();
        const fileName = "newSalvex/" + uuidv4() + "." + ext;
        Storage.put(fileName, selectedUploadMedia[i], {
          completeCallback: (event) => {},
          progressCallback: (progress) => {},
          errorCallback: (err) => {},
        }).then((result) => {
          if (type === "doc") {
            const payload = {
              image: "public/" + result.key,
              name: docTitle,
            };

            privateFileUpload(payload, props?.selectedListing?.id, (res) => {
              if (res?.status === 200) {
                getProductDetailListingRefresh(props?.selectedListing?.id, (res2) => {
                  if (res2.status === 200) {
                    const data = { ...detail };
                    data.documents = res2.data.privateDocuments;
                    setDocTitle("");

                    setDetail(data);
                  } else {
                    toast(<AlertError message={res2.response.data.message || "Something went wrong"} />);
                  }
                  setProgress("completed");
                  setSelectedUploadMedia([]);
                  setLoadingMedia(false);
                  toast(<AlertSuccess message="Information Saved" />);
                  ref.current && ref.current.complete();
                });
              } else {
                toast(<AlertError message={res.response.data.message || "Something went wrong"} />);
                setProgress("failed");
                setLoadingMedia(false);
                ref.current && ref.current.complete();
              }
            });
          } else {
            const payload = {
              image: "public/" + result.key,
            };

            imageUpload(payload, props?.selectedListing?.id, (res) => {
              if (res?.status === 200) {
                getProductDetailListingRefresh(props?.selectedListing?.id, (res2) => {
                  if (res2.status === 200) {
                    const data = { ...detail };
                    data.images = res2.data.pics;
                    setDetail(data);
                  } else {
                    toast(<AlertError message={res2.response.data.message || "Something went wrong"} />);
                  }
                  setProgress("completed");
                  setSelectedUploadMedia([]);
                  getAuctionListingPictures(props?.selectedListing?.id, (res3) => {
                    if (res3.status === 200) {
                      props?.setImages(res3.data);
                    }
                  });
                  setLoadingMedia(false);
                  ref.current && ref.current.complete();
                });
              } else {
                toast(<AlertError message={res.response.data.message || "Something went wrong"} />);
                setProgress("failed");
                setLoadingMedia(false);
                ref.current && ref.current.complete();
              }
            });
          }
        });
      }
    }
  };
  const handleEditImageUploader = async () => {
    if (editedFile?.length > 0) {
      setLoadingMedia(true);
      setProgress("uploading");
      ref.current && ref.current.continuousStart();
      const file = dataURLtoFile(editedFile, "savlex");
      const fileName = "newSalvex/" + uuidv4() + ".jpeg";
      Storage.put(fileName, file, {
        completeCallback: (event) => {},
        progressCallback: (progress) => {},
        errorCallback: (err) => {},
      }).then((result) => {
        const payload = {
          image: "public/" + result.key,
          picture_id: selectedImage.picture_id,
        };

        imageUpload(payload, props?.selectedListing?.id, (res) => {
          if (res?.status === 200) {
            getProductDetailListingRefresh(props?.selectedListing?.id, (res2) => {
              if (res2.status === 200) {
                const data = { ...detail };
                data.images = res2.data.pics;
                setDetail(data);
                setLoadingMedia(false);
                ref.current && ref.current.complete();
              } else {
                toast(<AlertError message={res2.response.data.message || "Something went wrong"} />);
              }
              setProgress("completed");
              setOptionType("");
              setEditedFile([]);
              setSelectedUploadMedia([]);
              getAuctionListingPictures(props?.selectedListing?.id, (res3) => {
                if (res3.status === 200) {
                  props?.setImages(res3.data);
                }
              });
            });
          } else {
            toast(<AlertError message={res.response.data.message || "Something went wrong"} />);
            setProgress("failed");
            setLoadingMedia(false);
            ref.current && ref.current.complete();
          }
        });
      });
    }
  };

  useEffect(() => {
    if (optionType === "scribble" && editedFile.length > 0) {
      ref?.current?.continuousStart();
      handleEditImageUploader();
    }
  }, [editedFile]);

  useEffect(() => {
    const offcanvas = document.querySelector(".offcanvas");
    if (offcanvas) {
      offcanvas.removeAttribute("tabindex");
    }
    setTimeout(() => {
      inputRef?.current?.focus();
    }, 100);
  }, [optionType]);

  useEffect(() => {
    if (detail?.images?.length > 0) {
      let items = [];
      detail?.images?.map((ep) =>
        items.push({
          original:
            ep.s_path.substring(0, 5) === "https"
              ? `${ep.s_path}${ep.filename}_lp.${ep.suffix}`
              : `${process.env.GATSBY_MEDIA_URL}${ep.s_path}${ep.filename}_lp.${ep.suffix.toLowerCase()}`,
          thumbnail:
            ep.s_path.substring(0, 5) === "https"
              ? `${ep.s_path}${ep.filename}_lp.${ep.suffix}`
              : `${process.env.GATSBY_MEDIA_URL}${ep.s_path}${ep.filename}_lp.${ep.suffix.toLowerCase()}`,
        }),
      );
      props?.setTitle && props?.setTitle(`${detail?.auction_id} - ${detail?.title}`);
      props?.setImgData(items);
    }
  }, [detail?.images]);

  //Popover
  const popoverClick =
    optionType === "edit" ? (
      <Popover
        className="popover"
        id="popover-positioned-top"
        title="Popover top"
        bsPrefix=" popover custom-popover border-0 rounded-0"
      >
        <Popover.Body>
          <div class="d-flex align-content-center" onClick={(e) => e.stopPropagation()}>
            <input
              ref={inputRef}
              type="text"
              placeholder="Enter Image Title"
              className="form-control flex-grow-1"
              value={title}
              onClick={(e) => e.stopPropagation()}
              onChange={(e) => setTitle(e.target.value)}
            />
            <button
              type="button"
              class={`addClickButton-brand d-flex align-items-center justify-content-center ${
                loadingMedia || !title ? "btn-disabled " : ""
              }`}
              onClick={(e) => {
                e.stopPropagation();
                handleSaveTitle();
                // setShowBackdrop(false);
              }}
            >
              <img src={save} alt="" />
            </button>
          </div>
        </Popover.Body>
      </Popover>
    ) : (
      <Popover></Popover>
    );

  return (
    <>
      <LoadingBar height={5} color="var(--brand-color2)" ref={ref} />
      <Offcanvas
        className={`offcanvas offcanvas-dashboard ${props?.isLeftOpen ? "offcanvas-start" : "offcanvas-end"}  `}
        backdropClassName="modal-backdrop edit-backdrop"
        placement={props?.isLeftOpen ? "start" : "end"}
        show={props?.show}
        data-bs-focus="false"
        renderStaticNode={false}
      >
        <Offcanvas.Header className="offcanvas-header justify-content-between">
          <h5 id="offcanvasRightLabel">Edit Listing</h5>
          <div class="d-flex align-items-center">
            <button
              type="button"
              class="btn-close text-reset"
              data-bs-dismiss="offcanvas"
              aria-label="Close"
              onClick={() => {
                setOptionType("");
                setEditedFile([]);
                props?.onHide();
              }}
              onHide={() => {
                setOptionType("");
                setEditedFile([]);
                props?.onHide();
              }}
            ></button>
          </div>
        </Offcanvas.Header>
        <Offcanvas.Body className="offcanvas-body p-0">
          <div class="offcanvas-dashboard-tab">
            <nav>
              <div class="nav nav-tabs" id="nav-tab" role="tablist">
                <div class={`nav-link ${tab === "information" ? "active" : ""} `} onClick={() => setTab("information")}>
                  Product Information
                </div>
                <div class={`nav-link ${tab === "location" ? "active" : ""} `} onClick={() => setTab("location")}>
                  Product Location
                </div>
                <div class={`nav-link ${tab === "pricing" ? "active" : ""} `} onClick={() => setTab("pricing")}>
                  Qty & Pricing
                </div>
                <div
                  class={`nav-link ${tab === "images" ? "active" : ""} `}
                  onClick={() => {
                    setTab("images");
                    setSelectedUploadMedia([]);
                  }}
                >
                  Images
                </div>
                <div
                  class={`nav-link ${tab === "docs" ? "active" : ""} `}
                  onClick={() => {
                    setTab("docs");
                    setSelectedUploadMedia([]);
                  }}
                >
                  Documents
                </div>
              </div>
            </nav>
            <div class="tab-content" id="nav-tabContent">
              {tab === "information" && (
                <div
                  class={`tab-pane fade ${tab === "information" ? "show active" : ""} `}
                  id="nav-odt1"
                  role="tabpanel"
                  aria-labelledby="nav-odt1-tab"
                >
                  <div class="offcanvas-dashboard-body">
                    <form class="row g-4">
                      <div class="col-12">
                        <label for="title" class="form-label">
                          Title of Item
                        </label>
                        <input
                          type="text"
                          class="form-control"
                          id="title"
                          name="title"
                          onChange={onchange}
                          value={detail?.title}
                        />
                      </div>

                      <div class="col-md-12">
                        <label for="description" class="form-label">
                          Description
                          <span>
                            Please provide a detailed description of the item you are selling. If you do not have a
                            detailed description or you have submitted the information via email, please provide a brief
                            description of the item.
                          </span>
                        </label>

                        <Editor
                          name="task"
                          className={"form-control"}
                          onChange={(data) => {
                            setDescpSavedData(data);
                          }}
                          editorLoaded={true}
                          value={descpSavedData}
                        />
                      </div>
                      <div class="col-md-12">
                        <label class="form-label" for="conditionType">
                          Condition
                        </label>
                        <Select
                          value={detail?.conditionType}
                          className="basic-single"
                          classNamePrefix="select-search"
                          getOptionLabel={(option) => option.name}
                          getOptionValue={(option) => option.value}
                          name="conditiontype"
                          options={conditionOptions}
                          placeholder={""}
                          styles={customStyles}
                          onChange={(a) => {
                            const value = { ...detail };
                            value.conditionType = a;
                            setDetail(value);
                          }}
                        />
                        {detail?.conditionType?.value == "Others" ? (
                          <div class="row" style={{ marginTop: "20px" }}>
                            <div class="col-md-6">
                              <input
                                class="form-control"
                                id="otherCondition"
                                name="otherCondition"
                                onChange={(e) => {
                                  setOtherCondition(e.target.value);
                                }}
                                value={otherCondition}
                              />
                            </div>
                          </div>
                        ) : (
                          ""
                        )}
                      </div>
                      <div class="col-md-12">
                        <label class="form-label" name="condition">
                          Condition Description
                          <span>
                            Please provide a brief description of why the item is available, any present damage, age and
                            how long it has been stored.
                          </span>
                        </label>
                        <Editor
                          name="condition"
                          className={"form-control"}
                          onChange={(data) => {
                            setConditionDescpData(data);
                          }}
                          editorLoaded={true}
                          value={conditionDescpData}
                        />
                      </div>
                      <div className="col-md-12 d-flex justify-content-end align-items-center">
                        <a
                          href="javascript:void(0)"
                          class={`btn btn-brand-color2 text-uppercase ${loadingUpdate && "button-disabled"}`}
                          onClick={(e) => doSubmit(e)}
                        >
                          Save
                        </a>
                      </div>
                    </form>
                  </div>
                </div>
              )}
              {tab === "location" && (
                <div
                  class={`tab-pane fade ${tab === "location" ? "show active" : ""} `}
                  id="nav-odt2"
                  role="tabpanel"
                  aria-labelledby="nav-odt2-tab"
                >
                  <div class="offcanvas-dashboard-body">
                    <form class="row g-4">
                      <div class="col-md-6">
                        <label for="c_name" class="form-label">
                          Contact
                        </label>
                        <input
                          type="text"
                          class="form-control"
                          id="c_name"
                          name="c_name"
                          value={detail?.c_name}
                          onChange={onchange}
                        />
                      </div>
                      <div class="col-md-6">
                        <label for="company" class="form-label">
                          Company
                        </label>
                        <input
                          type="text"
                          class="form-control"
                          id="company"
                          name="company"
                          value={detail?.company}
                          onChange={onchange}
                        />
                      </div>
                      <div class="col-md-6">
                        <label for="c_phone" class="form-label">
                          Phone
                        </label>
                        <input
                          type="text"
                          class="form-control"
                          id="c_phone"
                          name="c_phone"
                          value={detail?.c_phone}
                          onChange={onchange}
                        />
                      </div>
                      <div class="col-md-6">
                        <label for="c_fax" class="form-label">
                          Fax
                        </label>
                        <input
                          type="number"
                          class="form-control"
                          id="c_fax"
                          name="c_fax"
                          value={detail?.c_fax}
                          onChange={onchange}
                        />
                      </div>
                      <div class="col-md-6">
                        <label for="c_email" class="form-label">
                          Email
                        </label>
                        <input
                          type="email"
                          class="form-control"
                          id="c_email"
                          name="c_email"
                          value={detail?.c_email}
                          onChange={onchange}
                        />
                      </div>
                      <div class="col-md-6">
                        <label for="address_1" class="form-label">
                          Address
                        </label>
                        <input
                          type="text"
                          class="form-control"
                          id="address_1"
                          name="address_1"
                          value={detail?.address_1}
                          onChange={onchange}
                        />
                      </div>
                      <div class="col-md-6">
                        <label for="city" class="form-label">
                          City
                        </label>
                        <input
                          type="text"
                          class="form-control"
                          id="city"
                          name="city"
                          value={detail?.city}
                          onChange={onchange}
                        />
                      </div>
                      <div class="col-md-6">
                        <label for="zip" class="form-label">
                          Zip
                        </label>
                        <input
                          type="text"
                          class="form-control"
                          id="city"
                          name="zip"
                          value={detail?.zip}
                          onChange={onchange}
                        />
                      </div>

                      <div class="col-md-6">
                        <label class="form-label">Country</label>
                        <Select
                          value={detail?.country}
                          className="basic-single"
                          classNamePrefix="select-search"
                          getOptionLabel={(option) => option.name}
                          getOptionValue={(option) => option.value}
                          name="country"
                          options={[
                            {
                              label: "Popular",
                              options: [
                                { name: "United States", value: "1001" },
                                { name: "Canada", value: "1039" },
                              ],
                            },
                            {
                              label: "All",
                              options:
                                allCountries &&
                                allCountries.length > 0 &&
                                allCountries
                                  .filter((op) => op.country_id != "1001" && op.country_id != "1039")
                                  .map((ee) => ({
                                    name: ee.description,
                                    value: ee.country_id,
                                  })),
                            },
                          ]}
                          placeholder={""}
                          styles={customStyles}
                          onChange={(e) => {
                            const data = { ...detail };
                            const error = { ...errors };
                            data.country = e;
                            data.state = {};
                            setDetail(data);
                            setErrors(error);
                          }}
                        />
                      </div>
                      <div class="col-md-6">
                        <label class="form-label">State (if USA)</label>
                        <Select
                          value={detail?.state}
                          className="basic-single"
                          classNamePrefix="select-search"
                          getOptionLabel={(option) => option.name}
                          getOptionValue={(option) => option.value}
                          name="state"
                          options={
                            detail?.country && detail?.country && detail?.country.value != "1001"
                              ? [{ name: "International", value: "1001" }]
                              : allStates &&
                                allStates.length > 0 &&
                                allStates
                                  .filter((item) => item.state_id != "1001")
                                  .map((ee) => ({
                                    name: ee.description,
                                    value: ee.state_id,
                                  }))
                          }
                          placeholder={""}
                          styles={customStyles}
                          onChange={(e) => {
                            const data = { ...detail };
                            const error = { ...errors };
                            data.state = e;
                            delete error.state;
                            setDetail(data);
                            setErrors(error);
                          }}
                        />
                      </div>
                      <div className="col-md-12 d-flex justify-content-end align-items-center">
                        <a
                          href="javascript:void(0)"
                          class={`btn btn-brand-color2 text-uppercase ${loadingUpdate && "button-disabled"}`}
                          onClick={(e) => doSubmit(e)}
                        >
                          Save
                        </a>
                      </div>
                    </form>
                  </div>
                </div>
              )}
              {tab === "pricing" && (
                <div
                  class={`tab-pane fade ${tab === "pricing" ? "show active" : ""} `}
                  id="nav-odt3"
                  role="tabpanel"
                  aria-labelledby="nav-odt3-tab"
                >
                  <div class="offcanvas-dashboard-body">
                    <form class="row g-4">
                      <div class="col-md-6">
                        <label for="quantity" class="form-label">
                          Quantity
                        </label>
                        <input
                          type="number"
                          class="form-control"
                          id="quantity"
                          name="quantity"
                          disabled={props?.status == "pending" || props?.status == "Pending" ? false : true}
                          value={detail?.quantity}
                        />
                      </div>
                      <div class="col-md-6">
                        <label for="unit" class="form-label">
                          Unit
                        </label>
                        <input
                          type="text"
                          class="form-control"
                          id="unit"
                          name="unit"
                          onChange={onchange}
                          value={detail?.unit}
                        />
                      </div>
                      <div class="col-md-6">
                        <label for="wholesale_value" class="form-label">
                          Wholesale Value
                        </label>
                        <div class="form-control-outer position-relative">
                          <input
                            type="text"
                            class="form-control"
                            id="wholesale_value"
                            name="wholesale_value"
                            value={detail?.wholesale_value}
                            onChange={onchange}
                          />
                          <div class="input-currency-tag">USD</div>
                        </div>
                      </div>
                      <div class="col-md-6">
                        <label for="retail_value" class="form-label">
                          Retail Value
                        </label>
                        <div class="form-control-outer position-relative">
                          <input
                            type="text"
                            class="form-control"
                            id="retail_value"
                            name="retail_value"
                            value={detail?.retail_value}
                            onChange={onchange}
                          />
                          <div class="input-currency-tag">USD</div>
                        </div>
                      </div>
                      <div class="col-md-6">
                        <label for="inputClaimPrice" class="form-label">
                          Claim Price
                        </label>
                        <div class="form-control-outer position-relative">
                          <input
                            type="text"
                            class="form-control"
                            id="claim_value"
                            name="claim_value"
                            value={detail?.claim_value}
                            onChange={onchange}
                          />
                          <div class="input-currency-tag">USD</div>
                        </div>
                      </div>
                      <div class="col-md-6">
                        <label for="reserve_price" class="form-label">
                          Reserve Price
                        </label>
                        <div class="form-control-outer position-relative">
                          <input
                            type="text"
                            class="form-control"
                            id="reserve_price"
                            name="reserve_price"
                            value={detail?.reserve_price}
                            onChange={onchange}
                          />
                          <div class="input-currency-tag">USD</div>
                        </div>
                      </div>
                      <div className="col-md-12 d-flex justify-content-end align-items-center">
                        <a
                          href="javascript:void(0)"
                          class={`btn btn-brand-color2 text-uppercase ${loadingUpdate && "button-disabled"}`}
                          onClick={(e) => doSubmit(e)}
                        >
                          Save
                        </a>
                      </div>
                    </form>
                  </div>
                </div>
              )}
              {tab === "images" &&
                (optionType === "crop" || optionType === "rotate" ? (
                  <div class="offcanvas-dashboard-body">
                    <div className="d-flex justify-content-between">
                      <h6>{optionType === "crop" ? "Crop Image" : optionType === "rotate" ? "Rotate Image" : ""}</h6>
                      <button
                        type="button"
                        class="btn-close text-reset"
                        onClick={() => {
                          setOptionType("");
                          setEditedFile([]);
                        }}
                      ></button>
                    </div>
                    {props.progress === "uploading" ? (
                      <div class="progress-row d-flex align-items-center justify-content-between">
                        <div class="row-progress-label" role="progressbar">
                          Please wait while image is being saved
                        </div>
                      </div>
                    ) : props.progress === "completed" ? (
                      <div class="progress-row d-flex align-items-center justify-content-between">
                        <div class="row-progress-label" role="progressbar">
                          Images has been saved successfully
                        </div>
                      </div>
                    ) : (
                      ""
                    )}
                    <div
                      class={`offcanvas-widget-row ${
                        optionType === "crop" || (optionType === "rotate" && "padding-top-0")
                      }`}
                    >
                      <Edit
                        image={selectedImage}
                        setEditedFile={setEditedFile}
                        ref={childRef}
                        optionType={optionType}
                      />

                      <div class="owr-column-button d-grid gap-2 d-md-flex justify-content-md-end">
                        <button
                          type="button"
                          class="btn btn-brand-color2-outline"
                          onClick={() => {
                            setOptionType("");
                            setEditedFile([]);
                          }}
                        >
                          <span style={{ color: "black" }}> Cancel</span>
                        </button>
                        {optionType === "rotate" && (
                          <button
                            type="button"
                            class="btn btn-default btn-yellow "
                            onClick={() => childRef.current.handleRotate()}
                          >
                            <img src={cropNew} alt="crop" />
                            <span style={{ color: "white", marginLeft: "5px" }}>Rotate</span>
                          </button>
                        )}
                        <button
                          type="button"
                          class={`btn btn-brand-color2 ${loadingMedia ? "disabled" : ""}`}
                          onClick={() => !loadingMedia && handleEditImageUploader()}
                        >
                          {loadingMedia ? "Please Wait" : "Save"}
                        </button>
                      </div>
                    </div>

                    {/* <div class={`popover-overlay ${showBackdrop && "open"}`}></div> */}
                  </div>
                ) : optionType === "scribble" ? (
                  <div class="offcanvas-dashboard-body">
                    <div className="d-flex justify-content-between">
                      <h6>Scribble Image</h6>
                      <button
                        type="button"
                        class="btn-close text-reset"
                        onClick={() => {
                          setOptionType("");
                          setEditedFile([]);
                        }}
                      ></button>
                    </div>

                    {props.progress === "uploading" ? (
                      <div class="progress-row d-flex align-items-center justify-content-between">
                        <div class="row-progress-label" role="progressbar">
                          Please wait while image is being saved
                        </div>
                      </div>
                    ) : props.progress === "completed" ? (
                      <div class="progress-row d-flex align-items-center justify-content-between">
                        <div class="row-progress-label" role="progressbar">
                          Image has been saved successfully
                        </div>
                      </div>
                    ) : (
                      ""
                    )}
                    <div class={`offcanvas-widget-row ${optionType === "scribble" && "padding-top-0"}`}>
                      <Scrib
                        image={selectedImage}
                        setEditedFile={setEditedFile}
                        ref={scribbleRef}
                        handleEditImageUploader={handleEditImageUploader}
                        loadingUpload={loadingMedia}
                      />

                      <div
                        class="owr-column-button d-grid gap-2 d-md-flex justify-content-md-end"
                        style={{ marginRight: "10px" }}
                      >
                        <button
                          type="button"
                          class="btn btn-brand-color2-outline"
                          onClick={() => scribbleRef.current.clear()}
                        >
                          <span style={{ color: "black" }}> Clear</span>
                        </button>

                        <button
                          type="button"
                          class={`btn btn-brand-color2 ${loadingMedia ? "disabled" : ""}`}
                          onClick={() => {
                            scribbleRef.current.handleClick();
                          }}
                        >
                          {loadingMedia ? "Please Wait" : "Save"}
                        </button>
                      </div>
                    </div>

                    {/* <div class={`popover-overlay ${showBackdrop && "open"}`}></div> */}
                  </div>
                ) : (
                  <div
                    class={`tab-pane fade ${tab === "images" ? "show active" : ""} `}
                    id="nav-odt4"
                    role="tabpanel"
                    aria-labelledby="nav-odt4-tab"
                  >
                    {progress === "uploading" ? (
                      <div class="progress-row d-flex align-items-center justify-content-between">
                        <div class="row-progress-label" role="progressbar">
                          Please wait while images are being uploaded
                        </div>
                      </div>
                    ) : progress === "completed" ? (
                      <div class="progress-row d-flex align-items-center justify-content-between">
                        <div class="row-progress-label" role="progressbar">
                          Images have been uploaded successfully
                        </div>
                      </div>
                    ) : (
                      ""
                    )}
                    <div class="offcanvas-dashboard-body">
                      <div class="image-upload-box">
                        <h6>Upload Images</h6>
                        <div class="image-upload-input position-relative">
                          <div class="image-upload-input-text text-center">
                            <h6>+ Upload Images</h6>
                            <p>Supported file format : Jpeg, Png</p>
                          </div>
                          <input
                            class="form-control"
                            type="file"
                            multiple
                            accept=".jpg,.jpeg,.png"
                            onChange={(e) => {
                              onSelectMedia(e, "image");
                            }}
                            onClick={(e) => (e.target.value = null)}
                          />
                        </div>
                        <div class="owr-column">
                          {selectedUploadMedia && selectedUploadMedia?.length > 0 ? (
                            <div className="selected-image-parent d-flex flex-wrap">
                              {selectedUploadMedia?.map((item, i) => (
                                <>
                                  <div class="selected-image">
                                    <img src={`${URL.createObjectURL(selectedUploadMedia[i])}`} alt="" />
                                    <a
                                      style={{ cursor: "pointer" }}
                                      class="selected-image-closed"
                                      onClick={() => removeUploaded(selectedUploadMedia[i])}
                                    >
                                      <img src={closeIcon} alt="" />
                                    </a>
                                  </div>
                                </>
                              ))}
                            </div>
                          ) : (
                            ""
                          )}
                        </div>

                        <div class="d-flex justify-content-end mt-4">
                          <a
                            href="javascript:void(0)"
                            class={`btn btn-brand-color2 ${
                              (loadingMedia || selectedUploadMedia?.length === 0) && "button-disabled"
                            }`}
                            onClick={() => onUploadMedia("image")}
                          >
                            Upload
                          </a>
                        </div>
                      </div>
                      {detail?.images?.length > 0 && (
                        <>
                          <div class="offcanvas-body-divider"></div>

                          <div class="uploaded-image-container">
                            <h6>All Images</h6>
                            <div class="uploaded-image-list d-flex flex-wrap">
                              {detail?.images &&
                                detail?.images.length > 0 &&
                                detail?.images.map((im, i) => (
                                  <div class="uploaded-image-item">
                                    <div class="uploaded-image-box">
                                      <div class="uib-img position-relative">
                                        <img
                                          src={
                                            im.s_path.substring(0, 5) === "https"
                                              ? `${im.s_path}${im.filename}_lp.${im.suffix.toLowerCase()}`
                                              : "https://" +
                                                `${process.env.GATSBY_APP_S3_BUCKET}${im.s_path}${
                                                  im.filename
                                                }_lp.${im.suffix.toLowerCase()}`
                                          }
                                          alt={im.filename}
                                        />
                                        <div class="uib-img-title">{im?.caption}</div>
                                      </div>
                                      <div class="uib-icons-list d-flex flex-wrap">
                                        <a
                                          href="javascript:void(0)"
                                          onClick={(e) => {
                                            e.stopPropagation();
                                            handlePrimayImg(im?.picture_id);
                                          }}
                                          class="uib-icon-box"
                                        >
                                          <img src={im?.picture_id_new ? yellowFeatured : featured} alt="" />
                                        </a>
                                        <OverlayTrigger
                                          trigger="click"
                                          placement="top"
                                          rootClose
                                          overlay={popoverClick}
                                          bsPrefix="show"
                                          onToggle={() => {
                                            if (optionType === "edit") {
                                              setOptionType("");
                                            }
                                          }}
                                        >
                                          <img
                                            src={tag}
                                            className="cursor-pointer"
                                            alt=""
                                            onClick={(e) => {
                                              e.stopPropagation();
                                              if (!loadingMedia) {
                                                setOptionType("edit");
                                                // setShowBackdrop(true);
                                                setTitle(im.caption ? im.caption : "");
                                                setOptionTypeId(im.picture_id);
                                              }
                                            }}
                                          />
                                        </OverlayTrigger>
                                        <a href="javascript:void(0)" class="uib-icon-box">
                                          <img
                                            src={crop}
                                            alt=""
                                            onClick={(e) => {
                                              e.stopPropagation();
                                              setOptionType("crop");
                                              setSelectedImage(im);
                                            }}
                                          />
                                        </a>
                                        <a href="javascript:void(0)" class="uib-icon-box">
                                          <img
                                            src={rotate}
                                            alt=""
                                            onClick={(e) => {
                                              e.stopPropagation();
                                              setOptionType("rotate");
                                              setSelectedImage(im);
                                            }}
                                          />
                                        </a>
                                        <a href="javascript:void(0)" class="uib-icon-box">
                                          <img
                                            src={scribble}
                                            alt=""
                                            onClick={(e) => {
                                              e.stopPropagation();
                                              setOptionType("scribble");
                                              setSelectedImage(im);
                                            }}
                                          />
                                        </a>
                                        <a
                                          href="javascript:void(0)"
                                          class="uib-icon-box"
                                          onClick={(e) => {
                                            e.stopPropagation();
                                            e.preventDefault();
                                            setSelectedMedia(im);
                                            toggleDeleteModal();
                                          }}
                                        >
                                          <img src={deleteIcon} alt="" />
                                        </a>
                                      </div>
                                    </div>
                                  </div>
                                ))}
                            </div>
                          </div>
                        </>
                      )}
                    </div>
                  </div>
                ))}
              {tab === "docs" && (
                <div
                  class={`tab-pane fade ${tab === "docs" ? "show active" : ""} `}
                  id="nav-odt5"
                  role="tabpanel"
                  aria-labelledby="nav-odt5-tab"
                >
                  {progress === "uploading" ? (
                    <div class="progress-row d-flex align-items-center justify-content-between">
                      <div class="row-progress-label" role="progressbar">
                        Please wait while document is being uploaded
                      </div>
                    </div>
                  ) : progress === "completed" ? (
                    <div class="progress-row d-flex align-items-center justify-content-between">
                      <div class="row-progress-label" role="progressbar">
                        Document has been uploaded successfully
                      </div>
                    </div>
                  ) : (
                    ""
                  )}
                  <div class="offcanvas-dashboard-body">
                    <p>
                      Documents must be in PDF, XLS, XLSX, DOC, DOCX or CSV format. You must specify a title for each
                      document.
                    </p>
                    <form class="row g-4">
                      <div class="col-md-12">
                        <label class="form-label">Select a File Type</label>
                        <select class="form-select " onChange={(e) => setFileType(e.target.value)}>
                          <option className="doc-option" value=".pdf">
                            PDF
                          </option>
                          <option value=".csv">CSV</option>
                          <option value=".xls">XLS</option>
                          <option value=".xlsx">XLSX</option>
                          <option value=".doc">DOC</option>
                          <option value=".docx">DOCX</option>
                        </select>
                      </div>
                      <div class="col-12">
                        <label for="formFile" class="form-label">
                          Select Document
                        </label>
                        <div class="custom-type-file position-relative d-flex flex-wrap">
                          <div class="ctf-badge d-flex flex-wrap flex-grow-1">
                            <div>
                              {" "}
                              {selectedUploadMedia && selectedUploadMedia?.length > 0 && selectedUploadMedia[0]?.name}
                              {selectedUploadMedia && selectedUploadMedia?.length ? (
                                <img
                                  class="cross-icon-box ms-2"
                                  src={closeIcon}
                                  alt=""
                                  onClick={() => setSelectedUploadMedia([])}
                                />
                              ) : (
                                <p>Please select any document</p>
                              )}
                            </div>
                          </div>
                          <a href="javascript:void(0)" class="ctf-cta flex-shrink-0">
                            Upload
                          </a>
                          <input
                            class="form-control"
                            id="formFile"
                            type="file"
                            accept={`${fileType}`}
                            onChange={(e) => onSelectMedia(e, "doc")}
                            onClick={(e) => (e.target.value = null)}
                          />
                        </div>
                        {errors && errors?.document ? errors?.document : ""}
                      </div>
                      <div class="col-md-12">
                        <label for="inputDocTitle" class="form-label">
                          Document Title
                        </label>
                        <input
                          type="text"
                          class="form-control"
                          id="inputDocTitle"
                          value={docTitle}
                          onChange={(e) => setDocTitle(e.target.value)}
                        />
                        {errors && errors?.docTitle ? errors?.docTitle : ""}
                      </div>
                      <div class="d-flex justify-content-end mt-4">
                        <a
                          href="javascript:void(0)"
                          class={`btn btn-brand-color2 ${
                            (loadingMedia || selectedUploadMedia?.length === 0) && "button-disabled"
                          }`}
                          onClick={() => {
                            if (!validateTitle()) {
                              onUploadMedia("doc");
                            }
                          }}
                        >
                          Upload
                        </a>
                      </div>
                    </form>

                    {detail?.documents && detail?.documents?.length > 0 && (
                      <>
                        <div class="offcanvas-body-divider"></div>
                        <div class="uploaded-file-container">
                          <h6>All Documents</h6>
                          <div class="uploaded-file-list">
                            {detail?.documents.map((d, i) => (
                              <div class="uploaded-file-item">
                                <div class="uploaded-file-box d-flex justify-content-between">
                                  <div class="ufb-content d-flex flex-grow-1 space-between align-items-center">
                                    <div class="ufb-content d-flex flex-grow-1">
                                      <div class="ufb-icon d-flex align-items-center">
                                        <img src={pdfIcon} alt="" />
                                      </div>
                                      <div
                                        class="ufb-file-name align-self-center cursor-pointer"
                                        onClick={() =>
                                          window.open(
                                            d.s_path.substring(0, 5) === "https"
                                              ? `${d.filename}`
                                              : `https://${process.env.GATSBY_APP_S3_BUCKET}${d.filename}`,
                                          )
                                        }
                                      >
                                        {d.name}
                                      </div>
                                    </div>
                                    <a
                                      href="javascript:void(0)"
                                      class="uib-icon-box"
                                      onClick={(e) => {
                                        e.preventDefault();
                                        setSelectedMedia(d);
                                        toggleDeleteModal();
                                      }}
                                      style={{ height: "34px" }}
                                    >
                                      <img src={deleteIcon} alt="" />
                                    </a>
                                  </div>
                                </div>
                              </div>
                            ))}
                          </div>
                        </div>
                      </>
                    )}
                  </div>
                </div>
              )}
            </div>
            <div class={`popover-overlay ${optionType === "edit" || optionType === "delete" ? "open " : ""}`}></div>
          </div>
        </Offcanvas.Body>
        <DeleteModal
          show={deleteModal}
          handleClose={() => toggleDeleteModal()}
          message={"Are you sure you want to delete?"}
          loading={loadingMedia}
          handleDelete={selectedMedia?.picture_id ? handleDeleteImg : handleDeleteDoc}
        />
      </Offcanvas>
    </>
  );
};

export default React.memo(EditListing);
